export class GlobalOperations {
  static BaseUrl: string = "https://ccapi.albinasoft.com/api";

  static get isProd(): boolean {
    return GlobalOperations.BaseUrl === "https://ccapi.albinasoft.com/api";
  }
  static IsNullOrEmpty(value: string | null | undefined): boolean {
    return value === null || value === undefined || value.trim() === "";
  }

  static consoleLog(data: object) {
    if (!GlobalOperations.isProd) {
      console.log(data);
    }
  }
}
